document.addEventListener("DOMContentLoaded", () => {
  const inputSearch = document.querySelector(`.search__input[name="q"]`);
  if (!inputSearch) return;

  let debounceTimer;
  inputSearch.addEventListener("input", (e) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      window.dispatchEvent(new Event('scroll'));
    }, 300);
  });
});
